// Types
import type { SxProps } from '@mui/material'
// Components
import { Button } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
// Internal types
interface IUploadButtonProps {
  label: string
  sx?: SxProps
  onUpload: (files: FileList | null) => void
  multiple?: boolean
  variant?: 'contained' | 'outlined'
}

export default function UploadButton({
  label,
  sx,
  onUpload,
  multiple = true,
  variant = 'outlined',
}: IUploadButtonProps) {
  return (
    <Button
      component="label"
      role={undefined}
      variant={variant}
      color="secondary"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      sx={sx}
    >
      {label}
      <input
        type="file"
        style={{ height: 0, width: 0 }}
        multiple={multiple}
        onChange={(event) => {
          onUpload(event.target.files)
        }}
      />
    </Button>
  )
}
